"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.en = void 0;
const en = exports.en = {
  Announcements: {
    LoadError: 'Announcements failed to load',
    NoAnnouncements: 'There are currently no announcements to display',
    Title: 'Announcements from ICIS',
    Type: {
      Correction: 'Correction Notice',
      FinalizedPrice: 'Finalised Price Notice',
      Global: 'Global Notice',
      Report: 'Report Notice'
    }
  },
  General: {
    Cancel: 'Cancel',
    Close: 'Close',
    Error: 'General error',
    Menu: 'Menu',
    Reload: 'Reload',
    Search: 'Search'
  },
  HeaderMenus: {
    Analytics: {
      CarbonAnalytics: 'Carbon Analytics',
      LngAnalytics: 'LNG Analytics',
      PowerAnalytics: 'Power Analytics',
      Energy: {
        GroupName: 'Energy',
        CarbonForesight: 'Carbon Foresight',
        EULTPower: 'EU Long-Term Power Analytics',
        Gas: 'Gas Foresight',
        HydrogenPricing: 'Hydrogen Pricing & Analytics',
        LNG: 'LNG Foresight',
        PowerForesight: 'Power Foresight',
        PowerShortTermForecast: 'Power Short-Term Forecast'
      },
      Chemicals: {
        GroupName: 'Chemicals',
        LiveDisruptionsTrackerImpact: 'Live Disruptions Tracker - Impact',
        LiveDisruptionsTrackerSupply: 'Live Disruptions Tracker - Supply',
        MarginAnalytics: 'Margin Analytics',
        SupplierCarbonFootprints: 'Supplier Carbon Footprints',
        SupplyAndDemand: 'Supply & Demand Database'
      },
      Recycling: {
        GroupName: 'Recycling',
        RPETPricingAndAnalytics: 'R-PET Pricing & Analytics',
        RecyclingSupplyTrackerChemical: 'Recycling Supply Tracker - Chemical',
        RecyclingSupplyTrackerMechanical: 'Recycling Supply Tracker - Mechanical'
      },
      Refining: {
        GroupName: 'Refining',
        ChinaRefinery: 'China Refinery Operating Analysis'
      }
    },
    Commodities: {
      AllSubscribed: 'All Subscribed Commodities',
      Favourites: 'Favourites',
      Filter: 'Filter',
      NoMatches: 'No matches found',
      NoSubscribedCommodities: 'You are currently not subscribed to any of our commodity hub pages'
    },
    Contact: {
      Contact: 'Contact Us',
      Email: 'Email',
      LiveChat: 'Live Chat',
      Phone: 'Phone',
      Telephone: 'Telephone'
    },
    Help: {
      Credits: 'Credits Help',
      IcisServicesHelp: 'ICIS Services Help',
      IcisSupportHub: 'ICIS Support Hub',
      Methodology: 'Methodology',
      PlatformTraining: 'Platform Training',
      PublishingSchedule: 'Publishing Schedule'
    },
    LoadError: 'Navigation failed to load',
    Main: {
      Analytics: 'Analytics',
      Commodities: 'Commodities',
      Contact: 'Contact',
      CreditsUsage: 'Credits Usage:',
      CreditReportFinder: 'Credit Report Finder',
      Dashboard: 'Dashboard',
      Home: 'Home',
      IntelligencePages: 'Topics',
      NewHome: 'New Home',
      News: 'News',
      ToolsAndServices: 'Tools & Services',
      WebminarCalendars: 'Live Webinars'
    },
    News: {
      AdvancedSearch: 'Advanced Search',
      LatestNews: 'Latest News',
      Magazine: 'Magazine',
      MySavedArticles: 'My Saved Articles',
      MySavedSearches: 'My Saved Searches',
      NewsChanEnergyFocus: 'Energy Focus',
      NewsChanInsightAnalysis: 'Insight & Analysis',
      NewsChanLatest: 'News Stream',
      NewsChanMagazine: 'Magazine',
      NewsChanOverview: 'Front Page',
      NewsChanSavedSearches: 'Saved Searches',
      RssFeeds: 'RSS Feeds',
      ReadingList: 'Reading List',
      AlertsAndSettings: 'Alerts & Settings'
    },
    Profile: {
      ChangePassword: 'Change Password',
      CookiePolicy: 'Cookie Policy',
      Logout: 'Logout',
      MyPreferences: 'My Preferences',
      PrivacyPolicy: 'Privacy Policy',
      TermsAndConditions: 'Terms and Conditions'
    },
    ToolsAndServices: {
      Alerts: 'Alerts',
      ApiDataAccess: 'API Data Access',
      CommodityAlerts: 'Commodity Alerts',
      Conferences: 'Conferences',
      Consultancy: 'Consultancy',
      Credits: 'Credits Usage: ',
      CreditReportFinder: 'Credit Report Finder',
      DownloadApp: 'ICIS App',
      ExcelPlugin: 'Excel Plug-in',
      ExchangeRates: 'XE.com Exchange Rates',
      ExploreAllServices: 'Explore ICIS Services',
      LiveDisruptionsImpact: 'Live Disruptions Tracker - Impact',
      LiveDisruptionsSupply: 'Live Disruptions Tracker - Supply',
      Lsdt: 'Live Supply Disruptions',
      MarginAnalytics: 'Margin Analytics',
      PriceOptimisation: 'Price Optimisation',
      RPET: 'Recycled PET Data',
      SupplyAndDemand: 'Supply and Demand Database',
      Training: 'Training',
      Tools: 'Tools',
      Services: 'Services'
    }
  },
  NavIconAccessibilityText: {
    announcements: 'Announcements',
    help: 'Help',
    search: 'Search',
    user: 'Profile'
  },
  RequestTool: {
    unlockData: 'Unlock data',
    notifyUs: 'Notify us',
    requestAccess: 'Request Access',
    requestSent: 'Request sent',
    requestFailed: 'Request failed',
    done: 'Done',
    receiveData: {
      success: 'Your Account Manager will be in touch to discuss next steps',
      errorTittle: 'We couldn’t complete your request at this point.',
      errorSubTitle: 'Please try again later.'
    }
  }
};